<template lang="">
  <FullScreenLayout>
    <template #page-content="props">
      <v-row class="fill-height justify-center">
        <v-col
          class="d-none d-sm-flex justify-center"
          style="justify-content: center; align-items: center"
          sm="6"
          lg="8"
        >
          <WelcomeSlide></WelcomeSlide>
        </v-col>
        <v-col class="fill-height justify-center" style="width: 50%">
          <v-card xs="12" sm="12" tile elevation="0">
            <FormNewOwner
              v-bind:page="pageIndex"
              v-bind:jwt="jwt"
            ></FormNewOwner>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </FullScreenLayout>
</template>

<style lang="scss">
#navbar-right {
}
#particles-js {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.mainPage[isMobile] #frm-login {
  position: fixed;
  top: 0px;
  left: 0px;
  border-radius: 0 !important;
  right: 0;
  bottom: 0;
}
.form-card {
  margin: auto;
}
</style>

<script>
import EasyPlanClient from "../utils/EasyPlanClient";
import FormNewOwner from "../components/OwnerRegistration/FormNewOwner";
import WelcomeSlide from "../components/WelcomePage/WelcomeSlide.vue";
import FullScreenLayout from "../layout/FullScreenLayout.vue";
export default {
  data: function () {
    return {
      pageIndex: 0,
      jwt: "",
      isMobile: false,
    };
  },
  components: {
    FormNewOwner,
    FullScreenLayout,
    WelcomeSlide,
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.checkIfIsMobile();
    });
    this.checkIfIsMobile();
  },
  computed: {},
  methods: {
    checkIfIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
  },
  created() {
    if (this.$route.query != undefined) {
      if (this.$route.query.action != undefined)
        switch (this.$route.query.action) {
          case "account-verification":
            this.pageIndex = 3;
            break;
          case "company-creation":
            this.pageIndex = 4;
            break;
          default:
            this.pageIndex = 0;
            break;
        }
      if (this.$route.query.jwt != undefined) this.jwt = this.$route.query.jwt;
    } else {
      if (
        localStorage.userToken != undefined &&
        localStorage.userToken != "null"
      ) {
        console.debug("redirecting");
        EasyPlanClient.SetJWT(localStorage.userToken);
        this.$router.push({
          name: "owner-dashboard",
        });
      }
    }
  },
};
</script>
